import { Editor } from "tinymce";


export function addDefaultMenus(editor:Editor){
    const name = "remove-item"
    editor.ui.registry.addMenuItem(name, {
        icon: "remove",
        text: "Löschen",
        onAction: () => {
            const node = editor.selection.getNode();
            node.remove();
            editor.selection.collapse(false);
        }
    })
    return name;
}